/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ContainerFindingsForDockle extends models.ContainerFindings {
    constructor() {
        super();
        this.setDiscriminator("ContainerFindingsForDockle");
    }

    getFixupPrototypeFunction() { return ContainerFindingsForDockle.fixupPrototype; }

    static newInstance(model: Partial<ContainerFindingsForDockle>): ContainerFindingsForDockle {
        let obj = Object.assign(new ContainerFindingsForDockle(), model);
        ContainerFindingsForDockle.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ContainerFindingsForDockle>): ContainerFindingsForDockle {
        if (!model) return null;
        return ContainerFindingsForDockle.newInstance(<ContainerFindingsForDockle> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ContainerFindingsForDockle) {
        if (!obj) return;

        models.ContainerFindingsForDockle.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ContainerFindingsForDockle): boolean {
        if (models.ContainerFindings.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ContainerFindingsForDockle.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
